import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { UploadModule } from './components/upload/upload.module';
import { NgMaterialsModule } from './ng-materials/ng-materials.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ContentListComponent } from './pages/content-list/content-list.component';
import { ContentDetailComponent } from './components/content-detail/content-detail.component';
import { LoginComponent } from './pages/login/login.component';
import { DeleteConfirmComponent } from './components/dialogs/delete-confirm/delete-confirm.component';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { UrlGenComponent } from './components/url-gen/url-gen.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { PushConfirmComponent } from './components/dialogs/push-confirm/push-confirm.component';
import { ActivateConfirmComponent } from './components/dialogs/activate-confirm/activate-confirm.component';
import { CourseInventoryComponent } from './pages/course-inventory/course-inventory.component';
import { AppBaseComponent } from './components/app-base/app-base.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { QaLinksComponent } from './pages/qa-links/qa-links.component';
import { CoursecompleteComponent } from './pages/coursecomplete/coursecomplete.component';

@NgModule({
  declarations: [
    AppComponent,
    ContentListComponent,
    ContentDetailComponent,
    LoginComponent,
    ResetPasswordComponent,
    DeleteConfirmComponent,
    UrlGenComponent,
    PushConfirmComponent,
    ActivateConfirmComponent,
    CourseInventoryComponent,
    CoursecompleteComponent,
    AppBaseComponent,
    NavBarComponent,
    QaLinksComponent
  ],
  entryComponents: [DeleteConfirmComponent, PushConfirmComponent, ActivateConfirmComponent],//dynamically added components!
  imports: [
    BrowserModule,
    AppRoutingModule,
    UploadModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatDialogModule,
    MatToolbarModule, MatIconModule, MatProgressBarModule, MatListModule, MatButtonModule, NgMaterialsModule
  ],
  providers: [{ provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } }],
  bootstrap: [AppComponent]
})
export class AppModule { }
